<template>
	<div class="basic-layout-root">
		<v-app-bar
			absolute
			flat
			elevate-on-scroll
			color="white"
			height="72"
			class="copyright-app-bar"
			:scroll-target="`#${id}`"
		>
			<div class="copyright-app-bar__inner">
				<slot name="header">
					<v-img
						:src="require('../../assets/logo-wide.svg')"
						contain
						class="copyright-app-bar__logo"
						max-height="40"
						max-width="150"
					/>
				</slot>
			</div>
		</v-app-bar>
		<v-sheet :id="id" class="copyright-sheet overflow-y-auto" max-height="100vh">
			<v-container class="copyright-container">
				<slot name="content"></slot>
			</v-container>
		</v-sheet>
	</div>
</template>

<script>
export default {
	props: ["id"]
};
</script>

<style lang="scss" scoped>
.basic-layout-root {
	position: relative;
	min-height: 100vh;
}

.copyright-app-bar {
	border-bottom: 1px solid rgba(0, 0, 0, 0.07) !important;
	backdrop-filter: saturate(180%) blur(12px);
	background: rgba(255, 255, 255, 0.92) !important;
	z-index: 4;
	transition: box-shadow 0.2s ease;
}

.copyright-app-bar__inner {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding-top: 4px;
}

.copyright-app-bar__logo {
	flex: 0 0 auto;
}

.copyright-sheet {
	/* !important: Vuetify's .theme--light.v-sheet ties this selector's specificity,
	   so without it the white theme background wins depending on CSS load order */
	background: #f4f5f7 !important;
	padding-top: 80px;
}

.copyright-container {
	max-width: 760px !important;
}
</style>
